import React from 'react';
import { motion } from 'framer-motion';

const Rituals = () => {
  return (
    <section id="rituals" className="bg-[#f2f1ef]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-40">
        <div className="mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-stone-400 block mb-6">Step-by-Step Efficacy</span>
            <h2 className="font-serif text-4xl md:text-6xl text-stone-900 leading-tight">The Modern <br /><span className="italic font-light">Ritual.</span></h2>
          </div>
          <p className="text-stone-500 font-light max-w-sm text-lg leading-relaxed">
            Three intentional steps to anchor your morning and decompress your evening.
          </p>
        </div>

        <div className="space-y-32">
          {/* AM Ritual */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
            <div className="lg:col-span-7 order-2 lg:order-1">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                <div className="space-y-6">
                  <span className="block font-serif text-5xl text-stone-200">01</span>
                  <h4 className="text-xs font-bold uppercase tracking-widest">Awaken</h4>
                  <p className="text-sm text-stone-500 font-light leading-relaxed">Gently remove overnight toxins with lukewarm water and The Awakening Cleanser.</p>
                </div>
                <div className="space-y-6">
                  <span className="block font-serif text-5xl text-stone-200">02</span>
                  <h4 className="text-xs font-bold uppercase tracking-widest">Hydrate</h4>
                  <p className="text-sm text-stone-500 font-light leading-relaxed">Press Luminous Micro-Essence into damp skin to activate aquatic cell transport.</p>
                </div>
                <div className="space-y-6">
                  <span className="block font-serif text-5xl text-stone-200">03</span>
                  <h4 className="text-xs font-bold uppercase tracking-widest">Seal</h4>
                  <p className="text-sm text-stone-500 font-light leading-relaxed">Apply Barrier Defense Cream to lock in moisture and create a daily environmental shield.</p>
                </div>
              </div>
            </div>
            <div className="lg:col-span-5 order-1 lg:order-2">
              <motion.div 
                initial={{ opacity: 0, scale: 1.05 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className="relative aspect-[4/5] overflow-hidden"
              >
                <img src="https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=1000" alt="Morning Ritual" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-stone-900/5"></div>
                <div className="absolute top-8 right-8">
                  <p className="text-white text-[10px] font-bold tracking-[0.3em] uppercase vertical-text">Morning Ritual</p>
                </div>
              </motion.div>
            </div>
          </div>

          {/* PM Ritual */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
            <div className="lg:col-span-5">
              <motion.div 
                initial={{ opacity: 0, scale: 1.05 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className="relative aspect-[4/5] overflow-hidden"
              >
                <img src="https://images.unsplash.com/photo-1615397621946-880092288339?q=80&w=1000" alt="Evening Ritual" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-stone-900/5"></div>
                <div className="absolute top-8 left-8">
                  <p className="text-white text-[10px] font-bold tracking-[0.3em] uppercase vertical-text">Evening Ritual</p>
                </div>
              </motion.div>
            </div>
            <div className="lg:col-span-7">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                <div className="space-y-6">
                  <span className="block font-serif text-5xl text-stone-200">01</span>
                  <h4 className="text-xs font-bold uppercase tracking-widest">Dissolve</h4>
                  <p className="text-sm text-stone-500 font-light leading-relaxed">Break down makeup and SPF with an oil-based balm before your second cleanse.</p>
                </div>
                <div className="space-y-6">
                  <span className="block font-serif text-5xl text-stone-200">02</span>
                  <h4 className="text-xs font-bold uppercase tracking-widest">Repair</h4>
                  <p className="text-sm text-stone-500 font-light leading-relaxed">Massage Midnight Renewal Serum into skin to stimulate overnight collagen synthesis.</p>
                </div>
                <div className="space-y-6">
                  <span className="block font-serif text-5xl text-stone-200">03</span>
                  <h4 className="text-xs font-bold uppercase tracking-widest">Recover</h4>
                  <p className="text-sm text-stone-500 font-light leading-relaxed">A generous layer of Barrier Defense Cream provides the lipids needed for deep recovery.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rituals;